<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/system/businessManagement' }">用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>新增用户</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        
        <div>
          <el-form
            ref="myForm"
            label-width="140px"
            :model="formData"
            :rules="formRules"
            status-icon
            >
            <div class="part_title">
              <span>基础信息</span>
            </div>
            <el-form-item label="用户名称：" prop="company_name">
              <el-input v-model="formData.company_name" style="width: 300px" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="用户后缀：" prop="suffix">
              <el-input v-model="formData.suffix" style="width: 300px">
                <template slot="prepend">@</template>
              </el-input>
            </el-form-item>
            <el-form-item label="用户类型：" prop="company_type">
              <el-select v-model="formData.company_type" placeholder="请选择用户类型" style="width: 300px">
                <el-option label="企业用户" value="0"></el-option>
                <el-option label="政府用户" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="私有部署域名(IP)：" prop="domain">
              <el-input v-model="formData.domain" placeholder="请输入ip地址" style="width: 300px" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="私有域名接口地址：" prop="api_domain">
              <el-input v-model="formData.api_domain" placeholder="请输入接口地址" style="width: 300px" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="安全简报私有域名：" prop="report_domain">
              <el-input v-model="formData.report_domain" placeholder="请输入安全简报私有域名地址" style="width: 300px" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="负责人：" prop="contact_name">
              <el-input v-model="formData.contact_name" placeholder="请输入负责人姓名" style="width: 300px" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="负责人联系方式：" prop="contact_phone">
              <el-input v-model="formData.contact_phone" placeholder="请输入手机号" style="width: 300px" clearable autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="管理员账号：" prop="username">
              <el-input v-model="formData.username" clearable style="width: 300px" autocomplete="off">
                <template slot="append">@{{formData.suffix}}</template>
              </el-input>
            </el-form-item>
            <el-form-item label="管理员密码：" prop="password">
              <el-input v-model="formData.password" type="password" style="width: 300px" autocomplete="off" clearable></el-input>
            </el-form-item>
            <!-- 2020.9.11 v1.5新增 -->
            <el-form-item label="用户logo:" label-width="120px">
              <div v-if="formData.logo" style="margin-bottom: 10px;">
                <el-image
                  style="width: 60px; height: 60px"
                  :src="formData.logo"
                  fit="fill"
                  :preview-src-list="[formData.logo]"
                >
                </el-image>
              </div>
              <div>
                <el-upload
                  :action="imageUrl"
                  accept="image/*"
                  :show-file-list="false"
                  :data="imageData"
                  name="file"
                  v-model="formData.logo"
                  :on-success="handleUploadSuccess"
                >
                  <el-button size="small" type="primary">点击上传图片</el-button>
                </el-upload>
              </div>
            </el-form-item>

            <div class="part_title">
              <span>通用权限</span>
            </div>
            <el-form-item label="信息起始日期：" prop="times">
              <el-date-picker
                v-model="formData.information_start_time"
                type="date"
                placeholder="选择日期"
                @input="timeFn">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="涉及国家：" prop="country_limit_area_ids">
              <!-- 全部国家开关 -->
              <el-switch
                v-model="formData.open"
                active-color="#3ae2c4"
                inactive-color="#C0C4CC">
              </el-switch>
              全部国家
              <!-- 国家标签list -->
              <div class="country_group">
                <el-tag 
                v-for="(item,index) in formData.country_limit_area_list"
                class="country_item" 
                :key="index"
                type="info" 
                closable
                @close="handleClose(item)">{{item.area_name}}</el-tag>
              </div>
            </el-form-item>
            <!-- 涉及国家的新增框 -->
            <el-form-item v-show="!formData.open">
              <el-select v-model="formData.country" filterable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-button class="add_country" @click="countryAdd">新增</el-button>
            </el-form-item>

            <div class="part_title">
              <span>大屏信息</span>
            </div>
            <el-form-item label="关联大屏：" prop="board_ids">
              <div class="item" v-for="(item,index) in formData.board_list" :key="index">
                <el-tag @close="boardHandleClose(item)" class="board_item" type="info" closable>{{item.board_name}}</el-tag>
              </div>
              <el-select v-model="formData.board" filterable placeholder="请选择">
                <el-option
                  v-for="item in boardOptions"
                  :key="item.id"
                  :label="item.board_name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-button class="add_country" @click="boardAdd">新增</el-button>
            </el-form-item>

          </el-form>
        </div>

        <el-button style="margin-top: 10px" type="primary" @click="submitFn">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";
import commApi from "../../api/commonApi"
import {timestampToTime} from "@/mixins/tools.js"
import tokenService from "@/utils/services/token_service";
import lodash from '../../utils/tools/lodash';
export default {
  mixins: [timestampToTime],
  data() {
    return {
      checkList: [],
      disableList: [],
      tableData: [],
      nowType: '',
      role_id: Number(this.$route.query.id),
      formData: {
        company_name: '',  // 企业名字
        username: '',  // 管理员账号
        password: '',  // 管理员密码
        type: 3,       // 用户状态（1 试用，2正式试用，3停用 ）
        gov_type: 3,
        try_start_time: '',  // 试用开始时间
        try_end_time: '', // 试用结束时间
        open: false,
        country_limit_area_ids: '', // 涉及国家id
        country_limit_area_list: [],   // 涉及国家List
        board_ids: '', // 关联大屏ID
        board_list: [],   // 关联大屏list
        information_start_time: new  Date().getTime(),
      },
      formRules: {
        company_name: [{
          required: true,
          message: "用户名称不能为空",
          trigger: "blur"
        }],
        suffix: [{
          required: true,
          message: "用户后缀不能为空",
          trigger: "blur"
        }],
        company_type: [{
          required: true,
          message: "请选择用户类型",
          trigger: "blur"
        }],
        domain: [{
          // required: true,
          message: "请输入IP地址",
          trigger: "blur"
        }],
        api_domain: [{
          // required: true,
          message: "请输入接口地址",
          trigger: "blur"
        }],
        report_domain: [{
          message: "请输入安全简报私有域名地址",
          trigger: "blur"
        }],
        contact_name:[{
          required: true,
          message: "负责人不能为空",
          trigger: "blur"
        }],
        contact_phone:[{
          required: true,
          message: "负责人联系方式不能为空",
          trigger: "blur"
        }],
        username: [{
          required: true,
          message: "管理员账号不能为空",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "管理员密码不能为空",
          trigger: "blur"
        }],
        times: [{
          // required: true,
          message: "请选择信息起始时间",
          trigger: "blur"
        }],
        country_limit_area_ids: [{
          required: true,
          message: "请选择所涉及国家",
          trigger: "blur"
        }],
      },
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "logo"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      options: [],
      boardOptions: [],
    };
  },
  created() {
    // this.doEditExtra()
    this.areaListFn()
    this.BoardConfigListFn()
    // this.formData.times = []
    // this.formData.information_start_time = new  Date().getTime()
  },
  methods: {
    // 获取涉及国家下拉列表
    async areaListFn(){
      api.adminAreaList({pagesize:9999})
      .then(res =>{
        this.options = res.list
      })
      .catch(err =>{
        this.$message(err);
      })
    }, 
    // 获取大屏信息下拉列表
    async BoardConfigListFn(){
      api.adminBoardConfigList({pagesize: 9999,status: -1})
      .then(res =>{
        this.boardOptions = res.list
      })
      .catch(err =>{
        this.$message(err);
      })
    }, 
    // 图片上传成功
    handleUploadSuccess(res, file) {
      this.$set(this.formData, "logo", res.file);
    },
    // 时间
    timeFn(e) {
      this.$nextTick(() => {
        console.log(e);
        // this.formData.information_start_time = '';
        this.$set(this.formData, "information_start_time", e);
      });
      this.beforeValidate()
      console.log(this.formData.information_start_time);
    },
    // 获取当前企业详细信息
    async doEditExtra() {
      // this.formRules = Object.assign({}, this.formRulesOri)
      api.infoCompany({
        id: this.$route.query.id
      }).then(res => {
          this.formData = {times:[],...res.info}
          if(res.info.company_type==0){
            this.formData.company_type = "企业用户"
          }
          if(res.info.company_type==1){
            this.formData.company_type = "政府用户"
          }
          let name = this.formData.username.split("@")[0]
          // let suffix = this.formData.username.split("@")[1]
          this.formData.times.push(res.info.try_start_time * 1000)
          this.formData.times.push(res.info.try_end_time * 1000)
          this.formData.username = name
          // this.$set(this.formData,"suffix",suffix)
          console.log(this.formData.times);
        })
        .catch(err => {
          this.$message(err);
        });   
    },
    // 将起始时间转换为时间戳
    beforeValidate() {
      this.formData.information_start_time = this.$commFunc.parseToTimestamp(
        this.formData.information_start_time
      );
    },
    //  提交
    async submitFn(){
      this.beforeValidate()
      
      if(this.formData){
         this.formData.country_limit_area_ids = "0"
      }
      // 涉及国家不是全部国家时，将数组转换为用,分隔的字符串
      if(!this.formData.open){
        let arr = []
        for(let i=0;i<this.formData.country_limit_area_list.length;i++){
          arr.push(this.formData.country_limit_area_list[i].id)
        }
        this.formData.country_limit_area_ids = arr.join()
      }
      // 大屏
      let boardArr = []
      for(let i=0;i<this.formData.board_list.length;i++){
        boardArr.push(this.formData.board_list[i].id)
      }
      this.formData.board_ids = boardArr.join()
      console.log(this.formData);
      // 将数据提交
      api.addCompany({
        ...this.formData
      }).then(res => {
        this.$message("新增用户成功");
      })
      .catch(err => {
        this.$message(err);
      })
    },
    // 点击标签关闭按钮，删除涉及国家
    handleClose(tag) {
      this.formData.country_limit_area_list.splice(this.formData.country_limit_area_list.indexOf(tag), 1);
    },
    // 删除大屏
    boardHandleClose(tag) {
      this.formData.board_list.splice(this.formData.board_list.indexOf(tag), 1);
    },
    // 点击新增涉及国家
    countryAdd(){
      let val = ''
      let id =''
      for(let i=0;i<this.options.length;i++){
        if(this.options[i].id == this.formData.country){
          val = this.options[i].area_name
          id = this.options[i].id
        }
      }
      this.formData.country_limit_area_list.push({
        area_name: val,
        id: id
      })
    },
    // 新增大屏
    boardAdd(){
      let val = ''
      let id =''
      for(let i=0;i<this.boardOptions.length;i++){
        if(this.boardOptions[i].id == this.formData.board){
          val = this.boardOptions[i].board_name
          id = this.boardOptions[i].id
        }
      }
      this.formData.board_list.push({
        board_name: val,
        id: id
      }) 
    },
  },
};
</script>

<style lang="scss" scoped>
.part_title{
  font-size: 20px;
  span{
    border-bottom: 1px solid rgb(109, 186, 221);
  }
}
.country_group{
  margin-top: 10px;
  .country_item{
    margin-right: 16px;
  }
}
.add_country{
  margin-left: 10px;
}
.item{
  display: block;
  .board_item{
    // display: block;
    // min-width: 200px;
  }
}
</style>